const phoneimg = document.querySelector("#phoneimg");
// Reveal LCP image and first feature on DOMContentLoaded so we don't wait for window.onload (avoids huge element render delay)
document.addEventListener('DOMContentLoaded', function revealHeroAndFirstSlide() {
  if (phoneimg) phoneimg.classList.remove("hidden");
  const firstArticle = document.querySelector('#features .inner > article');
  if (firstArticle) firstArticle.classList.remove('hidden');
});

/* STICKY NAVIGATION - use IntersectionObserver to avoid getBoundingClientRect in scroll path (forced reflow) */
document.addEventListener('DOMContentLoaded', function() {
  const navContainer = document.querySelector('.nav-container');
  const logoDiv = document.querySelector('#hero .logodiv') || document.querySelector('.logodiv');
  if (!navContainer) return;

  // New homepage: nav stays visible
  if (document.body.classList.contains('page-home')) {
    navContainer.classList.add('visible');
    navContainer.style.transform = 'translateY(0)';
    navContainer.style.opacity = '1';
    navContainer.style.pointerEvents = 'auto';
    return;
  }

  if (!logoDiv) {
    navContainer.classList.add('visible');
    return;
  }
  
  let headerVisible = false;
  let logoOutOfView = false;
  
  const navObserver = new IntersectionObserver(function(entries) {
    if (!entries[0]) return;
    logoOutOfView = !entries[0].isIntersecting;
    if (logoOutOfView) {
      if (!headerVisible) {
        navContainer.classList.add('visible');
        navContainer.style.transform = 'translateY(0)';
        headerVisible = true;
      }
    } else {
      navContainer.classList.remove('visible');
      navContainer.style.transform = 'translateY(-100%)';
      headerVisible = false;
    }
  }, { threshold: 0, rootMargin: '0px' });
  navObserver.observe(logoDiv);
  
  document.querySelectorAll('.nav-links a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      if (targetId === '#') return;
      const targetElement = document.querySelector(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});


/* FEATURES */
const slides = document.querySelector('#features .inner');
const dots = document.querySelectorAll('#features .dot');
let currentIndex = 0;
let startX = 0;
let isDragging = false;
let currentTranslateX = 0;
let prevTranslateX = 0;
let animationID = 0;
let sliderViewportWidth = 0;

function updateSlider(index) {
  if (!slides || !dots || dots.length === 0) return;
  
  index = Math.max(0, Math.min(index, dots.length - 1));
  currentIndex = index;
  const articles = document.querySelectorAll('#features .inner > article');

  if (window.innerWidth > 800) {
    // Desktop: show all three in grid, no slider transform
    slides.style.transition = '';
    slides.style.transform = '';
    articles.forEach(function (a) { a.classList.remove('hidden'); });
    dots.forEach(function (d) { d.classList.remove('active'); });
    if (dots[index]) dots[index].classList.add('active');
    return;
  }

  // Mobile: single-slide slider
  const slideWidth = 33.33;
  currentTranslateX = -index * slideWidth;
  prevTranslateX = currentTranslateX;
  slides.style.transition = 'transform 0.3s ease';
  slides.style.transform = `translateX(${currentTranslateX}%)`;
  dots.forEach(function (d) { d.classList.remove('active'); });
  dots[index].classList.add('active');
  if (articles[index]) articles[index].classList.remove('hidden');
}

function getPositionX(event) {
  return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
}

function touchStart(event) {
  startX = getPositionX(event);
  sliderViewportWidth = window.innerWidth;
  isDragging = true;
  
  // Disable transition during drag
  slides.style.transition = 'none';
  
  // Stop any current animation
  cancelAnimationFrame(animationID);
  
  // Track starting position for drag
  startPos = currentTranslateX;
  
  // Add event listeners for move and end
  document.addEventListener('touchmove', touchMove);
  document.addEventListener('touchend', touchEnd);
  document.addEventListener('mousemove', touchMove);
  document.addEventListener('mouseup', touchEnd);
}

function touchMove(event) {
  if (isDragging) {
    if (sliderViewportWidth <= 0) sliderViewportWidth = window.innerWidth;
    const currentPosition = getPositionX(event);
    const diff = currentPosition - startX;
    const movePercent = (diff / sliderViewportWidth) * 100;
    currentTranslateX = prevTranslateX + movePercent;
    slides.style.transform = `translateX(${currentTranslateX}%)`;
  }
}

function touchEnd() {
  isDragging = false;
  
  // Re-enable transition
  slides.style.transition = 'transform 0.3s ease';
  
  // Calculate the threshold - require 15% of slide width for transition
  const threshold = 15;
  const movedPercent = currentTranslateX - prevTranslateX;
  
  if (movedPercent < -threshold && currentIndex < dots.length - 1) {
    // Swiped left - go to next slide
    updateSlider(currentIndex + 1);
  } else if (movedPercent > threshold && currentIndex > 0) {
    // Swiped right - go to previous slide
    updateSlider(currentIndex - 1);
  } else {
    // Return to original position
    updateSlider(currentIndex);
  }
  
  // Remove event listeners
  document.removeEventListener('touchmove', touchMove);
  document.removeEventListener('touchend', touchEnd);
  document.removeEventListener('mousemove', touchMove);
  document.removeEventListener('mouseup', touchEnd);
}

// Setup slider listeners only here; initial position is applied in DOMContentLoaded rAF to avoid forced reflow
if (slides && dots && dots.length > 0) {
  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      currentIndex = i;
      updateSlider(currentIndex);
    });
  });
  slides.addEventListener('touchstart', touchStart, { passive: true });
  slides.addEventListener('mousedown', touchStart);
}

// Stop context menu from appearing on touch and hold on slides
if (slides) {
  slides.addEventListener('contextmenu', (e) => {
    if (e.target.closest('#features .inner')) {
      e.preventDefault();
    }
  });
}

// Listen for window resize to fix slider positioning
window.addEventListener('resize', () => {
  // Wait for resize to complete
  setTimeout(() => {
    // Reset transform to current position
    updateSlider(currentIndex);
  }, 100);
});

// Initialize on load
window.addEventListener('load', () => {
if (slides) {
    updateSlider(currentIndex);
  }
});

// Batch initial style writes in one rAF to avoid forced reflow (Lighthouse)
document.addEventListener('DOMContentLoaded', function() {
  requestAnimationFrame(function() {
    const slider = document.querySelector('#features .inner');
    if (slides && dots && dots.length > 0) {
      updateSlider(0);
    } else if (slider) {
      slider.style.transform = 'translateX(0)';
      const first = document.querySelector('#features .inner > article');
      if (first) first.classList.remove('hidden');
    }
    document.body.style.overflowX = 'hidden';
  });
});


/* TESTIMONIALS SLIDER */
const testimonialSlides = document.querySelector('#testimonials .inner');
const testimonialDots = document.querySelectorAll('#testimonials .testimonial-dot');
let testimonialCurrentIndex = 0;
let testimonialStartX = 0;
let testimonialIsDragging = false;
let testimonialCurrentTranslateX = 0;
let testimonialPrevTranslateX = 0;
let testimonialAnimationID = 0;
let isMobileView = false;
let testimonialViewportWidth = 0;

function updateTestimonialSlider(index) {
  if (!testimonialSlides || !testimonialDots || testimonialDots.length === 0 || !isMobileView) return;
  
  // Contain index within bounds
  index = Math.max(0, Math.min(index, testimonialDots.length - 1));
  testimonialCurrentIndex = index;
  
  // Animate the slider movement - 100% width for each slide
  testimonialCurrentTranslateX = -index * 100;
  testimonialPrevTranslateX = testimonialCurrentTranslateX;
  
  testimonialSlides.style.transition = 'transform 0.3s ease';
  testimonialSlides.style.transform = `translateX(${testimonialCurrentTranslateX}%)`;
  
  // Update active dot
  testimonialDots.forEach(dot => dot.classList.remove('active'));
  testimonialDots[index].classList.add('active');
}

function getTestimonialPositionX(event) {
  return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
}

function testimonialTouchStart(event) {
  if (!isMobileView) return;
  
  testimonialStartX = getTestimonialPositionX(event);
  testimonialViewportWidth = window.innerWidth;
  testimonialIsDragging = true;
  
  // Disable transition during drag
  testimonialSlides.style.transition = 'none';
  
  // Stop any current animation
  cancelAnimationFrame(testimonialAnimationID);
  
  // Add event listeners for move and end
  document.addEventListener('touchmove', testimonialTouchMove);
  document.addEventListener('touchend', testimonialTouchEnd);
  document.addEventListener('mousemove', testimonialTouchMove);
  document.addEventListener('mouseup', testimonialTouchEnd);
}

function testimonialTouchMove(event) {
  if (testimonialIsDragging && isMobileView && testimonialViewportWidth > 0) {
    const currentPosition = getTestimonialPositionX(event);
    const diff = currentPosition - testimonialStartX;
    const movePercent = (diff / testimonialViewportWidth) * 100;
    
    testimonialCurrentTranslateX = testimonialPrevTranslateX + movePercent;
    testimonialSlides.style.transform = `translateX(${testimonialCurrentTranslateX}%)`;
  }
}

function testimonialTouchEnd() {
  if (!isMobileView) return;
  
  testimonialIsDragging = false;
  
  // Re-enable transition
  testimonialSlides.style.transition = 'transform 0.3s ease';
  
  // Calculate the threshold - require 20% of slide width for transition
  const threshold = 20;
  const movedPercent = testimonialCurrentTranslateX - testimonialPrevTranslateX;
  
  if (movedPercent < -threshold && testimonialCurrentIndex < testimonialDots.length - 1) {
    // Swiped left - go to next slide
    updateTestimonialSlider(testimonialCurrentIndex + 1);
  } else if (movedPercent > threshold && testimonialCurrentIndex > 0) {
    // Swiped right - go to previous slide
    updateTestimonialSlider(testimonialCurrentIndex - 1);
  } else {
    // Return to original position
    updateTestimonialSlider(testimonialCurrentIndex);
  }
  
  // Remove event listeners
  document.removeEventListener('touchmove', testimonialTouchMove);
  document.removeEventListener('touchend', testimonialTouchEnd);
  document.removeEventListener('mousemove', testimonialTouchMove);
  document.removeEventListener('mouseup', testimonialTouchEnd);
}

// Initialize testimonial slider only on mobile (rAF so innerWidth read is at frame start, not after DOM writes)
function initTestimonialSlider() {
  requestAnimationFrame(function() {
    isMobileView = window.innerWidth <= 900;
    if (!testimonialSlides) return;
    if (isMobileView) {
      // Reset transform for mobile view
      updateTestimonialSlider(0);
      
      // Setup dot click events if not already set up
      testimonialDots.forEach((dot, i) => {
        // Remove existing event listeners to prevent duplicates
        dot.removeEventListener('click', dotClickHandler);
        // Add new event listener
        dot.addEventListener('click', dotClickHandler);
      });
      
      // Setup touch and drag events
      testimonialSlides.addEventListener('touchstart', testimonialTouchStart, { passive: true });
      testimonialSlides.addEventListener('mousedown', testimonialTouchStart);
    } else {
      // Reset transform for desktop view
      testimonialSlides.style.transform = '';
    }
  });
}

// Click handler for dots
function dotClickHandler() {
  if (!isMobileView) return;
  const i = Array.from(testimonialDots).indexOf(this);
  testimonialCurrentIndex = i;
  updateTestimonialSlider(testimonialCurrentIndex);
}

// Initialize on load and resize
document.addEventListener('DOMContentLoaded', function() {
  initTestimonialSlider();
  
  // Listen for window resize to handle mobile/desktop switch
  window.addEventListener('resize', () => {
    // Wait for resize to complete
    clearTimeout(window.resizeTimer);
    window.resizeTimer = setTimeout(() => {
      initTestimonialSlider();
    }, 250);
  });
  
  // Stop context menu from appearing on touch and hold
  if (testimonialSlides) {
    testimonialSlides.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });
  }
});




/* ACCORDION (FAQ) SCRIPTS */
const headers = document.querySelectorAll(".accordion-header");

if (headers && headers.length > 0) {
  headers.forEach(header => {
    header.addEventListener("click", () => {
      // Get the currently open accordion item
      const open = document.querySelector(".accordion-content.show");
      const content = header.nextElementSibling;
      
      // Get all accordion headers for styling
      const allHeaders = document.querySelectorAll(".accordion-header");
      
      // First, reset all headers to default state
      allHeaders.forEach(h => {
        h.style.borderRadius = "8px";
        h.style.background = "#fff";
      });

      // If there's an open accordion and it's not the one we clicked
      if (open && open !== content) {
        open.classList.remove("show");
        const openSpan = open.previousElementSibling.querySelector("span");
        if (openSpan) openSpan.textContent = "+";
      }

      // Toggle the clicked accordion (CSS handles max-height via .accordion-content.show)
      if (content.classList.contains("show")) {
        content.classList.remove("show");
        const headerSpan = header.querySelector("span");
        if (headerSpan) headerSpan.textContent = "+";
        header.style.borderRadius = "8px";
        header.style.background = "#fff";
      } else {
        content.classList.add("show");
        const headerSpan = header.querySelector("span");
        if (headerSpan) headerSpan.textContent = "-";
        header.style.borderRadius = "8px 8px 0 0";
        header.style.background = "#f8f8f8";
        // Defer layout read to next frame (double rAF) so layout is clean and reflow isn’t forced
        header.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  });
}





/* CONTENT OBSERVER - no layout reads (getBoundingClientRect) in callback to avoid forced reflow */
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.remove('hidden');
    }
  });
}, {
  threshold: 0.15,
  rootMargin: '0px 0px -50px 0px'
});

// Observe all animate elements
document.querySelectorAll('.animate').forEach(el => {
  observer.observe(el);
});
/* Homepage testimonials carousel - show 3 / 2 / 1, then page to others */
document.addEventListener('DOMContentLoaded', function () {
  const root = document.querySelector('[data-home-quotes]');
  if (!root) return;

  const track = root.querySelector('.home-quotes-track');
  const viewport = root.querySelector('.home-quotes-viewport');
  const slides = Array.from(root.querySelectorAll('.home-quotes-slide'));
  const dotsWrap = root.querySelector('.home-quotes-dots');
  const prev = root.querySelector('.home-quotes-prev');
  const next = root.querySelector('.home-quotes-next');
  if (!track || !viewport || slides.length === 0 || !dotsWrap) return;

  let page = 0;
  let dots = [];

  function perView() {
    if (window.matchMedia('(max-width: 640px)').matches) return 1;
    if (window.matchMedia('(max-width: 980px)').matches) return 2;
    return 3;
  }

  function pageCount() {
    return Math.max(1, Math.ceil(slides.length / perView()));
  }

  function maxPage() {
    return pageCount() - 1;
  }

  function buildDots() {
    const count = pageCount();
    dotsWrap.innerHTML = '';
    dots = [];
    for (let i = 0; i < count; i++) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'home-quotes-dot' + (i === page ? ' is-active' : '');
      btn.setAttribute('aria-label', 'Show testimonials page ' + (i + 1));
      if (i === page) btn.setAttribute('aria-current', 'true');
      btn.addEventListener('click', function () { goTo(i); });
      dotsWrap.appendChild(btn);
      dots.push(btn);
    }
  }

  function applyTransform() {
    const view = perView();
    const first = page * view;
    const gap = parseFloat(getComputedStyle(track).gap) || 0;
    const slideWidth = slides[0].getBoundingClientRect().width;
    const offset = first * (slideWidth + gap);
    track.style.transform = 'translateX(-' + offset + 'px)';

    slides.forEach(function (slide, i) {
      const visible = i >= first && i < first + view;
      slide.classList.toggle('is-active', visible);
    });

    dots.forEach(function (dot, i) {
      const active = i === page;
      dot.classList.toggle('is-active', active);
      if (active) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }

  function goTo(nextPage) {
    const max = maxPage();
    page = ((nextPage % (max + 1)) + (max + 1)) % (max + 1);
    applyTransform();
  }

  if (prev) prev.addEventListener('click', function () { goTo(page - 1); });
  if (next) next.addEventListener('click', function () { goTo(page + 1); });

  root.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      goTo(page - 1);
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      goTo(page + 1);
    }
  });

  let startX = 0;
  let dragging = false;
  track.addEventListener('touchstart', function (e) {
    if (!e.touches[0]) return;
    startX = e.touches[0].clientX;
    dragging = true;
  }, { passive: true });
  track.addEventListener('touchend', function (e) {
    if (!dragging || !e.changedTouches[0]) return;
    dragging = false;
    const dx = e.changedTouches[0].clientX - startX;
    if (Math.abs(dx) < 40) return;
    goTo(dx < 0 ? page + 1 : page - 1);
  }, { passive: true });

  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      page = Math.min(page, maxPage());
      buildDots();
      applyTransform();
    }, 120);
  });

  buildDots();
  applyTransform();
});

/* Homepage: scroll reveal + section-aware nav */
document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('page-home')) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealNodes = document.querySelectorAll(
    '.home-feature, .home-trust, .home-section-head, .home-tile, .home-steps article, .home-show, .home-why article, .home-faq details, .home-close > h2, .home-close > p, .home-close .home-store-row'
  );

  revealNodes.forEach(function (el, i) {
    el.classList.add('home-reveal');
    if (el.classList.contains('home-tile') || el.matches('.home-steps article') || el.matches('.home-why article') || el.matches('.home-faq details')) {
      el.style.setProperty('--reveal-delay', ((i % 6) * 45) + 'ms');
    }
  });

  if (reduceMotion) {
    revealNodes.forEach(function (el) {
      el.classList.add('is-in');
    });
  } else if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealNodes.forEach(function (el) {
      revealObserver.observe(el);
    });
  } else {
    revealNodes.forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  var sectionIds = ['services', 'testimonials', 'faq-home'];
  var navMap = {
    services: document.querySelector('.nav-links a[href="#services"]'),
    testimonials: document.querySelector('.nav-links a[href="#testimonials"]'),
    'faq-home': document.querySelector('.nav-links a[href="/faq"]')
  };
  // FAQ nav goes to /faq page; highlight only in-page anchors
  var spyTargets = sectionIds
    .map(function (id) {
      return { id: id, el: document.getElementById(id), link: navMap[id] };
    })
    .filter(function (item) {
      return item.el && item.link && item.link.getAttribute('href').charAt(0) === '#';
    });

  if (!spyTargets.length || !('IntersectionObserver' in window)) return;

  var activeId = null;
  function setActive(id) {
    if (activeId === id) return;
    activeId = id;
    spyTargets.forEach(function (item) {
      if (item.id === id) item.link.classList.add('is-active');
      else item.link.classList.remove('is-active');
    });
  }

  var spyObserver = new IntersectionObserver(function (entries) {
    var visible = entries
      .filter(function (e) { return e.isIntersecting; })
      .sort(function (a, b) { return b.intersectionRatio - a.intersectionRatio; });
    if (visible[0] && visible[0].target.id) setActive(visible[0].target.id);
  }, { threshold: [0.18, 0.35], rootMargin: '-20% 0px -55% 0px' });

  spyTargets.forEach(function (item) {
    spyObserver.observe(item.el);
  });
});
